import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useContent } from '../context/ContentContext';

const FAQ = () => {
  const { faqs } = useContent();
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Questions & Answers
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0b2f5c] tracking-tight mb-4">
            Frequently asked
          </h2>
          <p className="text-slate-600 leading-relaxed">
            Everything you might want to know before you download.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((item, idx) => (
            <AccordionItem
              key={item.id || idx}
              value={`item-${idx}`}
              className="bg-slate-50 rounded-2xl border border-slate-200 px-6 data-[state=open]:border-sky-300 data-[state=open]:bg-white data-[state=open]:shadow-md transition-all"
            >
              <AccordionTrigger className="text-left text-[#0b2f5c] font-semibold hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
